import Enumerator from '../global/Enumerator';

export const objectivePayBallonOptions = [
  'none',
  'refinance',
  'trade_in_and_payout',
  'pay_cash'
];

export class ObjectivePayBallonOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'refinance';
        break;
      case '2':
        correctOption = 'trade_in_and_payout';
        break;
      case '3':
        correctOption = 'pay_cash';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ObjectivePayBallonOption.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  refinance: {
    get title() {
      return 'Refinance';
    }
  },
  trade_in_and_payout: {
    get title() {
      return 'Trade-in & payout';
    }
  },
  pay_cash: {
    get title() {
      return 'Pay cash';
    }
  }
});

export default {
  objectivePayBallonOptions,
  ObjectivePayBallonOption
};
